import {useEffect} from 'react';
import SVG from 'svg.js';
import {Asset} from '@deviceinsight/ng-ui-api-client';
import {getAssetDeviceType} from '../../ruleengine/ruleEditHelpers';
import {getSvgByDeviceType} from '../common/utils';
import {WidgetSvg} from '../floorplan/hooks/types';
import {DeviceType} from '../../../modules/ruleengine/config/consts';

const useDeviceSvg = (asset: Asset | null | undefined, key: string, setSvgRootObj: (arg0: WidgetSvg) => void) => {
	useEffect(() => {
		if (!asset) {
			return;
		}

		const type = getAssetDeviceType(asset);
		const svgCode = getSvgByDeviceType(type as DeviceType);

		const svgNodeParser = new DOMParser();
		const svgNodeDom = svgNodeParser.parseFromString(svgCode, 'application/xml');
		const svgNode = svgNodeDom.children[0];

		if (svgNode) {
			const idInWidget = `${key}_inDigitalTwinWidget`;
			svgNode.setAttribute('id', idInWidget);
			const containerId = `svg-digitaltwin-${key}`;
			const container = document.getElementById(containerId);

			if (container) {
				if (container.children.length) {
					container.removeChild(container.children[0]);
				}

				container.appendChild(svgNode);
				const svgRootObj = SVG(idInWidget);
				setSvgRootObj(svgRootObj as unknown as WidgetSvg);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [asset]);
};

export default useDeviceSvg;
